import { apiService } from './apiService';

export function getPermissionService(data) {
    return apiService({
        method: 'POST',
        url: '/permission/data',
        data,
        onSuccess: (dispatch, res) => {},
        onFailure: () => {},
    });
}

export function getByIdPermissionService(id) {
    return apiService({
        method: 'GET',
        url: '/permission/' + id,
        onSuccess: (dispatch, res) => {},
        onFailure: () => {},
    });
}

export function addPermissionService(data) {
    return apiService({
        method: 'POST',
        url: '/permission',
        data,
        onSuccess: (dispatch, res) => {},
        onFailure: () => {},
    });
}

export function updatePermissionService(id, data) {
    return apiService({
        method: 'PUT',
        url: '/permission/' + id,
        data,
        onSuccess: (dispatch, res) => {},
        onFailure: () => {},
    });
}

export function deletePermissionService(id) {
    return apiService({
        method: 'DELETE',
        url: '/permission/' + id,
        onSuccess: (dispatch, res) => {},
        onFailure: () => {},
    });
}
